import { get, put } from '@/services/http';
import Collection from './collection';

export interface PinnedReport {
  id: number;
  title: string;
  pinnedAt: string;
}

export class PinnedReportsCollection extends Collection<PinnedReport> {
  public async fetch(): Promise<PinnedReport[]> {
    const res: any = await get('/settings/pinned-reports');
    return Array.isArray(res?.data) ? res.data : [];
  }

  public async save(reports: PinnedReport[]): Promise<PinnedReport[]> {
    const res: any = await put('/settings/pinned-reports', { reports });
    return Array.isArray(res?.data) ? res.data : reports;
  }
}

export const pinnedReportsCollection = new PinnedReportsCollection();
